module.exports = __webpack_public_path__ + "media/images/categories/icon_cat26-66d729afa07329c320b490cea390bab0.svg";